import { ArrowBack, Send } from '@mui/icons-material'
import { Button, IconButton, TextField } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { LoadingButton } from '@mui/lab'
import { useNavigate } from 'react-router'
import AppBar from '../app-bar/AppBar'
import emailjs from '@emailjs/browser';
import Toast from '../Toast'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ReusableContactComponent() {

    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState("")
    const [autoCloseInMillis, setAutoCloseInMillis] = useState(1500)
    const form = useRef();
    const [buttonName, setButtonName] = useState("send")
    const [isLoading, setLoading] = useState(false)
    const [width, setWidth] = useState(0)

    const navigate = useNavigate()

    useEffect(() => {
        setWidth(window.innerWidth)
        console.log("width: ", width)
    }, [width])

    const handleClick = (e) => {
        navigate("/")
    }

    const submitMessage = (e) => {
        e.preventDefault();
        const SERVICE_ID = "service_qa0kuvb"
        const TEMPLATE_ID = "template_x9daifj"
        const PUBLIC_KEY = "csI6U3DLPILQ6sPFN"
        setLoading(true)
        setButtonName('sending')
        emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY)
            .then((result) => {
                if (result.text === 'OK') {
                    notify()
                    setEmail("")
                    setName("")
                    setMessage("")
                    setTimeout(() => {
                        navigate("/")
                    }, autoCloseInMillis + 1500);
                    setButtonName("send")
                    setLoading(false)
                }
            }, (error) => {
                console.log(error);
                setButtonName("send")
                setLoading(false)
            });

    }

    const notify = () => toast('message sent!', {
        position: width < 480 ? "top-center" : "top-right",
        autoClose: autoCloseInMillis,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: null,
    });
    return (
        <div className="wrapper">
            <div className="main_background">
                <div className='contact_wrapper'>
                    <form action="" ref={form} onSubmit={submitMessage}>
                        <div className="name_email">
                            <TextField type={'text'} name="user_name" onChange={(e) => setName(e.target.value)} value={name} color='error' className='name_input' label="name" placeholder='your name' />
                            <TextField type={'email'} name="user_email" onChange={(e) => setEmail(e.target.value)} value={email} color='error' className='email_input' label="email" placeholder='your-email@email.com' />
                        </div>
                        <div className="message">
                            <TextField name='message' type={'text'} onChange={(e) => setMessage(e.target.value)} value={message} color='error' multiline fullWidth rows={5} label="message" placeholder='type your message here ...' />
                        </div>

                        <div className="submit">
                            <div>
                                <IconButton onClick={handleClick}>
                                    <ArrowBack className='back_arrow' />
                                </IconButton>
                            </div>
                            {/* <Button onClick={submitMessage} variant='contained' className="submit_button" endIcon={<Send />}>send </Button> */}
                            <LoadingButton loading={isLoading} loadingPosition='end' onClick={submitMessage} className="submit_button" variant='contained' endIcon={<Send />}>{buttonName}</LoadingButton>
                        </div>
                    </form>
                    <Toast notify={notify} />

                </div>
            </div>
        </div>
    )
}

export default ReusableContactComponent